<template>
  <header data-v-e82090a2="" data-v-2ac6a5fc="" class="header-container">
    <div data-v-e82090a2="" class="top-nav">
      <div data-v-e82090a2="" class="top-nav-left">
        <span 
          data-v-e82090a2="" 
          class="back-icon" 
          @click="$router.back()"
          v-if="bankShow"
        >
          <i class="fas fa-chevron-left"></i>
        </span>
        <img 
          :src="$store.state.appInfo.site_logo" 
          alt="Logo" 
          class="logo-img" 
          @click="$parent.goNav('/')"
          v-else
        />
      </div>
      <div data-v-e82090a2="" class="top-nav-middle" v-if="titleShow">
        <h1 data-v-e82090a2="" class="page-title">
          <span data-v-e82090a2="">{{ title || $store.state.appInfo.title }}</span>
        </h1>
      </div>
      <div data-v-e82090a2="" class="top-nav-middle" v-else></div>
      <div data-v-e82090a2="" class="top-nav-right">
		<button class="top-nav-btn" @click="$parent.goNav('/')">
		  <i class="btn-icon fas fa-home"></i>
		  <span class="btn-text">首页</span>
		</button>  
		<button
		  class="top-nav-btn" 
		  @click="$parent.openKefu()" 
		>
		  <i class="btn-icon fas fa-comment"></i>
		  <span class="btn-text">客服</span>
		</button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      bankShow: false,
      titleShow: false,
      title: '',
    };
  },
  created() {
    this.changPath();
    if (!document.querySelector('link[href*="font-awesome"]')) {
      document.head.appendChild(Object.assign(document.createElement('link'), {
        rel: 'stylesheet',
        href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css'
		
      }));
    }
  },
  methods: {
    changPath() {
      let path = this.$route.path;
      if (path == '/') {
        this.bankShow = false;
        this.titleShow = false;
        this.title = '';
      }
      if (path == '/kefu') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '在线客服';
      }
      if (path == '/about') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '关于我们';
      }
      if (path == '/faq') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '帮助中心';
      }
      if (path == '/userCenter') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '会员中心';
      }
      if (path == '/accountCenter') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '账户中心';
      }
      if (path == '/resetPasswordNew') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '修改密码';
      }
      if (path == '/modifyPhone') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '设置手机号';
      }
      if (path == '/modifyEmail') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '设置邮箱';
      }
      if (path == '/modifyPayPassword') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '设置资金密码';
      }
      if (path == '/bankCard') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '我的银行卡';
      }
      if (path == '/addBankCard') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '添加银行卡';
      }
      if (path == '/addUsdtCard') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '添加USDT钱包';
      }
      if (path == '/myNews') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '我的消息';
      }
      if (path == '/myNewsInfo') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '消息详情';
      }
      if (path == '/assets') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '资产';
      }
      if (path == '/applyagent') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '申请代理';
      }
      if (path == '/applyagentList') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '活动申请记录';
      }
      if (path == '/activeList') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '优惠活动';
      }
      if (path == '/activeInfo') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '活动详情';
      }
      if (path == '/app') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = 'APP / 游戏下载';
      }
      if (path == '/sponsor') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = this.$store.state.appInfo.title + '风采';
      }
      if (path == '/vip') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = 'VIP专区';
      }
      if (path == '/deposit') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '存款';
      }
      if (path == '/withdraw') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '取款';
      }
      if (path == '/games') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '电子游戏大厅';
      }
      if (path == '/gamePage') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '';
      }
      if (path == '/welfare') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '福利中心';
      }
      if (path == '/hongbao') {
        this.bankShow = true;
        this.titleShow = true;
        this.title = '抢红包';
      }
	  if (path == '/yaoqing') {
	    this.bankShow = true;
	    this.titleShow = true;
	    this.title = '分享有礼';
	  }
    },
  },
  mounted() {
    // 保留原有的DOM操作逻辑（若无用可删除）
    $('.mask .close').click(function () {
      $(this).parents('.mask').fadeOut(300);
    });
    $('.user').hover(function () {
      $(this).find('.userImg .userNav').toggleClass('userNav--active');
    });
  },
  watch: {
    // 保留路由监听逻辑（路由变化时更新头部状态）
    $route: {
      immediate: true,
      handler() {
        this.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
$white: #ffffff;
$light-gray: #f9fafb;
$border-gray: #e5e7eb;
$accent: #165DFF;
$transition: all 0.3s ease;
.top-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 998;
  background: $white;
  border-bottom: 1px solid $border-gray;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  height: 50px;
}

// 左侧区域（Logo/返回按钮）
.top-nav-left {
  width: 44px;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;

  .logo-img {
    width: 44px;
    height: 44px;
    object-fit: contain;
  }

  .back-icon {
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #1f2937;
    font-size: 18px;
    &:hover {
      color: $accent;
    }
  }
}
.top-nav-middle {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  .page-title {
    font-size: 18px;
    color: #1f2937;
    font-weight: 600;
    margin: 0;
  }
}
.top-nav-right {
  display: flex;
  gap: 8px;
}
.top-nav-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  background: $light-gray;
  border: none;
  border-radius: 20px;
  padding: 5px 12px;
  cursor: pointer;
  font-size: 13px;
  color: #4b5563;
  transition: $transition;
  border: none;
  outline: none;

  &:hover {
    background: $accent;
    color: $white;
    transform: translateY(-2px);
  }

  .btn-icon {
    font-size: 14px;
  }
}
@media (max-width: 576px) {
  .top-nav {
    padding: 0 16px;
  }

  .top-nav-middle .page-title {
    font-size: 16px;
  }

  .top-nav-btn .btn-text {
    display: none;
  }

  .top-nav-btn {
    padding: 5px 10px;
    gap: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/libs/Header.vue